import React, { useEffect, useState } from "react";
import MultiSelect from "../MultiSelect/MultiSelect";
import {
  getroutinglevels,
  getroutinglevelsCountry,
  getroutinglevelsRegion,
} from "../../API/api";
import MultiSelectCm from "../MultiSelectCm/MultiSelectCm";
import MultiSelectCmTwo from "../MultiSelectCmTwo/MultiSelectCmTwo";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { filterDomainsForComponent2, getcurrentRoleValue } from "../../utils";
import { UserType } from "../cmOverview/UserType";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import { useLocation } from "react-router-dom";

export default function AdminRootFilter() {
  const state = useSelector((state) => state.cmRoot);
  const userState = useSelector((state) => state.user);
  const cmOverviewReducer = useSelector((state) => state.cmOverview);
  const dispatch = useDispatch();
  const currentPath = useLocation();
  const {
    cmRootRoutingData,
    cmRootUpdateRoutingVal,
    cmRootUpdateDomainVal,
    cmRootGetCountryData,
    cmRootGetRegionData,
    cmRootUpdateRegionVal,
    cmRootUpdateCountryVal,
    updatePageNoInSearchSuggestions,
    definedRegionObj,
    cmrUpdatePageNo,
    updatePageAMU
  } = bindActionCreators(Actions, dispatch);
  const onChangeDomain = (data) => {
    cmRootUpdateDomainVal(data);
    updatePageNoInSearchSuggestions(0);
    cmrUpdatePageNo(1);
  };
  const onChangeRoutingLevel = (data) => {
    // console.log('1', data);
    cmRootUpdateRoutingVal(data);
    updatePageNoInSearchSuggestions(0);
    cmrUpdatePageNo(1);
    updatePageAMU(0);
  };
  const onChangeGeoLevelCountry = (data) => {
    // console.log('1');
    updatePageNoInSearchSuggestions(0);
    cmRootUpdateCountryVal(data);
    cmrUpdatePageNo(1);
    updatePageAMU(0);
  };
  const onChangeGeoLevelRegion = (data) => {
    // console.log('1');
    updatePageNoInSearchSuggestions(0);
    cmRootUpdateRegionVal(data);
    cmrUpdatePageNo(1);
    updatePageAMU(0);
  };
  const fetchCountryData = (parent) => {
    getroutinglevelsCountry(parent).then((res) => {
      cmRootGetCountryData(res);
    });
  };
  const fetchRegionData = () => {
    getroutinglevelsRegion().then((res) => {
      cmRootGetRegionData(res);
    });
  };
  const fetchRoutingLevel = () => {
    getroutinglevels().then((res) => {
      let geoData =
        userState.geoAttributes["attributes"][
          getcurrentRoleValue(userState.roles)
        ]["routingLevels"];
      if (geoData?.atr1 === undefined && geoData?.atr2 === undefined) {
        cmRootRoutingData(res.data.data.concat([{label:'All',value:'All',name:'All'}]));
        fetchCountryData();
        fetchRegionData();
      } else {
        if (geoData?.atr1 === undefined && geoData?.atr2 !== undefined) {
          cmRootRoutingData([res.data.data[2],res.data.data[0], res.data.data[1],{label:'All',value:'All',name:'All'}]);
          definedRegionObj({
            name: geoData.atr2,
            label: geoData.atr2,
            value: geoData.atr2,
          });
          cmRootUpdateRegionVal({
            name: geoData.atr2,
            label: geoData.atr2,
            value: geoData.atr2,
          });
          fetchCountryData();
          fetchRegionData();
        }
        if (geoData.atr1 !== undefined && geoData.atr2 !== undefined) {
          cmRootRoutingData([res.data.data[1], res.data.data[2],res.data.data[0],{label:'All',value:'All',name:'All'}]);
          cmRootUpdateCountryVal({
            name: geoData.atr1,
            label: geoData.atr1,
            value: geoData.atr1,
          });
          fetchRegionData();
          fetchCountryData();
        }
      }
      // cmRootRoutingData(res.data.data);
      cmRootUpdateDomainVal(filterDomainsForComponent2(userState.cmTopics));
    });
  };
  const addData = (arr)=>{
    let obj = [{label:'All',value:'All',name:'All'}];
    let newArr = obj.concat(arr);
    return newArr;
  }
  useEffect(() => {
    if (state.routingData.length === 0) {
      fetchRoutingLevel();
    }
  }, []);


  return (
    <>
      <div
        style={{
          display: "flex",
          // justifyContent: "space-between",
          alignItems: "baseline",
        }}
      >
        {currentPath.pathname === "/cmHome/" && (
          <>
            {cmOverviewReducer.selectedTab === "1" ||
            cmOverviewReducer.selectedTab === "2" ||
            cmOverviewReducer.selectedTab === "4" ? (
              <>
                <label style={{ marginTop: "-8px", marginRight: "5px" }}>
                  User Type&nbsp;
                </label>
              </>
            ) : null}
          </>
        )}

        {/* <div style={{ display: "flex", alignItems: "baseline" }}> */}
        {currentPath.pathname === "/cmHome/" && (
          <>
            {cmOverviewReducer.selectedTab === "1" ||
            cmOverviewReducer.selectedTab === "2" ||
            cmOverviewReducer.selectedTab === "4" ? (
              <>
                <UserType />
              </>
            ) : null}
          </>
        )}
        <span style={{ marginLeft: "5px" }}>
          <MultiSelectCm
            value={state.selectedRouting}
            isMulti={false}
            onChangeFunc={onChangeRoutingLevel}
            options={state.routingData}
          />
        </span>
        <div style={{ marginLeft: "5px" }}>
          {state.selecetdRoutingValue === 1 && (
            <MultiSelectCm
              value={state.selectedGeoLevel}
              isMulti={false}
              onChangeFunc={onChangeGeoLevelCountry}
              options={state.countryData}
            />
          )}
          {state.selecetdRoutingValue === 2 && (
            <MultiSelectCm
              value={state.selectedGeoLevel}
              isMulti={false}
              onChangeFunc={onChangeGeoLevelRegion}
              options={state.regionData}
            />
          )}
          {/* </div> */}
        </div>
      </div>
    </>
  );
}
